import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const TimeClocking = {
	name: NAME,
	apiProvider,
	router,
};
